import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Joshwa D'mello </span>
            from <span className="purple"> Mumbai, India.</span>
            <br />My strong suit is creativity, which has been instrumental in my success in web design. 
            I have extensive experience building end-to-end website using the MERN stack.
            <br />
          </p>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
